import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  Text,
  HStack,
  Progress,
  Stack,
  useDisclosure,
  useBreakpointValue,
} from "@chakra-ui/react";
import React from "react";
import { OverlayRouter } from "../components/OverlayRouter";
import { ApplicationHeader } from "../tutor-application/application-steps/ApplicationHeader";

const TutorPageWrapper = ({
  children,
  id,
  verified,
  onLogout,
  isEmptyForms,
  currentStep,
}: {
  children: any;
  isEmptyForms?: boolean;
  currentStep?: string;
  activeStep?: string;
  id?: string;
  verified?: boolean;
  onLogout?: any;
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  React.useEffect(() => {
    if (isEmptyForms) {
      onOpen();
    } else {
      onClose();
    }
  }, [isEmptyForms]);

  return (
    <OverlayRouter>
      <Box boxSize="full" position="relative" bg="white">
        {/* <CustomPopupDisplay
          path="/welcome-modal"
          key={store.slug}
          isMobile={false}
          placement="left"
          displayCloseButton={false}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          isDesktopDrawer={true}
          isOpen={isOpen}
          onClose={onClose}
        >
          <BeginApplication
            onSubmit={() => {
              store.onStartApplication();
              onClose();
            }}
          />
        </CustomPopupDisplay> */}
        <ApplicationHeader onLogoutClick={onLogout} />
        <Box
          mx="auto"
          as="section"
          maxW={{ lg: "2xl" }}
          pb={{ base: 20, lg: 32 }}
          px={{ base: 5, lg: 8 }}
        >
          <Box id={id} className="forms-section">
            {children}
          </Box>
        </Box>
      </Box>
    </OverlayRouter>
  );
};

export default TutorPageWrapper;
